import {loading, stopLoading} from "../../loading";
import Axios from "axios";
import handleAjaxError from "../../handleAjaxError";
import {clearFeedbacksByName} from "../../forms";
import Swal from "sweetalert2";

class SingleFileUploadComponent {

	// noinspection JSUnusedLocalSymbols
	/**
	 * @param {HTMLElement} container
	 * @param {SingleFileUploadComponentDefs.Config} config
	 */
	constructor(container, config = {}) {
		this.config = config;

		this.container = container;
		this.previewContainer = container.querySelector('.file-preview-container');

		this.fileInput = container.querySelector('input[name="file"]');
		this.fileIdInput = container.querySelector('input[name="file_id"]');

		// Init buttons
		container.querySelectorAll('.change-file-button').forEach(button => {
			button.addEventListener('click', () => {
				this.fileInput.dispatchEvent(new MouseEvent('click'));
			})
		})

		// Init input file handler
		this.fileInput.addEventListener('change', () => {
			const file = this.fileInput.files[0];

			this.uploadFile(file)
		})

		// Init drag and drop
		this.previewContainer.addEventListener('drop', e => {
			e.preventDefault();

			// Hide dropzone
			this.previewContainer.classList.remove('show-dropzone');

			// Retrieve file
			let file = e.dataTransfer.items ?
				e.dataTransfer.items[0] :
				e.dataTransfer.files[0];

			if (file instanceof DataTransferItem) {
				file = file.getAsFile();
			}

			// Start upload
			this.uploadFile(file);
		})
		// Prevent opening file
		this.previewContainer.addEventListener('dragover', e => {
			e.preventDefault();
		})
		// Set dropzone class
		this.previewContainer.addEventListener('dragenter', () => {
			this.previewContainer.classList.add('show-dropzone');
		});
		this.previewContainer.addEventListener('dragleave', () => {
			this.previewContainer.classList.remove('show-dropzone');
		})
	}

	getFileId() {
		return this.fileIdInput.value;
	}

	/**
	 * @param {File} file
	 */
	uploadFile(file) {
		// Init file upload
		const uploadRoute = this.container
			.querySelector('input[name="upload_route"]')
			.value;

		const formData = new FormData();
		formData.append('file', file);

		// Update file name
		this.container.querySelector('.file-name').innerHTML = file.name;
		clearFeedbacksByName(this.container);

		// Mark preview as pending
		this.previewContainer.classList.remove('file-set');

		loading(this.container);

		Axios.post(
			uploadRoute,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				const file = response.data.media;

				// Update input
				this.fileIdInput.value = file.uuid;

				// Make footer button visible
				const footerButton = this.container
					.querySelector('.card-footer .change-file-button');

				footerButton.classList
					.remove('opacity-0');
				footerButton.classList
					.remove('pointer-events-none');

				// Set icon
				const iconElement = this.container.querySelector('.fa-icon');

				iconElement.className = `fa-icon ${file.icon}`;

				// Set link
				const iconLink = this.container.querySelector('.icon-link');

				iconLink.href = file.download_route;
				iconLink.title = 'Download File';

				// Update Preview
				this.previewContainer.classList.add('file-set');

				// Execute callback
				try {
					if (this.config.onUpload) {
						this.config.onUpload();
					}
				} catch (e) {
					console.error(e);
				}
			})
			.catch(error => {
				handleAjaxError(error, this.container)
			})
			.finally(() => {
				stopLoading(this.container);
			})
	}
}

/**
 * Checks if any file uploader inside domElement its
 * currently uploading something and displays a warning
 * about it if required. Returns a Promise that resolves if no
 * upload is occurring or the warning accepted
 *
 * @param domElement {Element}
 */
function checkForPendingUploads(domElement) {
	return new Promise((resolve) => {
		// Check element for current uploads
		const uploadInProgress = domElement.querySelector('.single-file-upload-container.loading');

		if (uploadInProgress) {
			const message = `
					One or more files are being uploaded, please wait for the upload to finish.
					<br/>
					If you continue anyway all uploaded files may not be saved.
			`;

			return Swal.fire({
				title: 'File upload in progress',
				html: message,
				icon: 'info',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Continue Anyway',
				cancelButtonText: 'Cancel',
			}).then(result => {
				if (result.isConfirmed) {
					resolve();
				}
			})
		} else {
			// Resolve immediately
			resolve();
		}
	})
}

export {
	SingleFileUploadComponent,
	checkForPendingUploads,
}
